<template>
  <div class="col-6 u-pull-left tag-container filter-tag-container">
    <div
      v-for="(tag, idx) of getTags()"
      :key="`tag-${idx}`"
      class="tag tag--success"
    >
      <strong>{{ tag }}</strong>
    </div>
  </div>
</template>
<style>
.filter-tag-container {
  margin-right: 0.75rem;
  margin-bottom: 1rem !important;
  padding-left: 1rem;
}
@media screen and (max-width: 768px) {
  .filter-tag-container {
    padding-left: 0.75rem;
    margin-top: -4rem;
    max-width: 60%;
  }
}
</style>
<script>
import { titleCase } from "@/functions/titleCase.function.js";

export default {
  name: "filter-tags",
  props: ["filterOptions"],
  methods: {
    getTags() {
      // options:  An array of Filter Objects
      var tags = [];
      for (let key in this.filterOptions) {
        if (!this.filterOptions[key]) {
          continue;
        }
        for (let item of this.filterOptions[key]) {
          if (item.selected) {
            tags.push(titleCase(key) + ": " + item["name"]);
          }
        }
      }
      return tags;
    }
  }
};
</script>
